export function NotFoundPage() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-navy-800">NotFound</h1>
      <div className="card">
        <p className="text-gray-500 text-sm">This page is under construction.</p>
      </div>
    </div>
  )
}
